export default "__VITE_ASSET__36e8c5bd__"